import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import axios from "axios";

// Pages Components
import WelcomeComp from "./WelcomeComp";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

// API YAPILANDIRMASI
const API_BASE_URL = "https://tazelyapi.stechomeyazilim.info";
const USERS_ENDPOINT = `${API_BASE_URL}/Users`;
const ORDERS_ENDPOINT = `${API_BASE_URL}/Complated_Order`; // Siparişlerin ana tablosu

const Dashboard = props => {
  // --- STATE YÖNETİMİ ---
  const [userCount, setUserCount] = useState(0);
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // --- VERİ ÇEKME (AXIOS) ---
  const fetchDashboardData = async () => {
    try {
      setIsLoading(true);
      
      // OData üzerinden paralel veri çekme
      const [usersRes, ordersRes] = await Promise.all([
        axios.get(`${USERS_ENDPOINT}/$count`), // Sadece toplam üye sayısını çekmek performanslıdır
        axios.get(`${ORDERS_ENDPOINT}`) // İstatistik analizi için siparişleri çek
      ]);

      setUserCount(usersRes.data); // OData /$count doğrudan sayı döner
      setOrders(ordersRes.data.value || []);
      
      setIsLoading(false);
    } catch (error) {
      console.error("Dashboard verileri yüklenemedi:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  // --- RAPOR HESAPLAMALARI ---
  const reports = [
    { 
      title: "Toplam Kullanıcı", 
      iconClass: "bx-user-circle", 
      description: userCount 
    },
    { 
      title: "Toplam Sipariş", 
      iconClass: "bx-copy-alt", 
      description: orders.length 
    },
    { 
      title: "Aktif Sipariş", 
      iconClass: "bx-purchase-tag-alt", 
      description: orders.filter((x) => x.Order_Status_ID === 1 || x.Order_Status_ID === 7).length 
    },
    { 
      title: "Tamamlanan Sipariş", 
      iconClass: "bx-check-double", 
      description: orders.filter((x) => x.Order_Status_ID === 3).length 
    },
    { 
      title: "İptal Sipariş", 
      iconClass: "bx-block", 
      description: orders.filter((x) => x.Order_Status_ID === 6).length 
    }
  ];

  //meta title
  document.title = "Anasayfa | Tazelya Admin Paneli";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Yönetim")}
            breadcrumbItem={props.t("Anasayfa")}
          />

          <Row>
            <Col xl="4">
              <WelcomeComp />
            </Col>
            <Col xl="8">
              <Row>
                {reports.map((report, key) => (
                  <Col md="4" key={"_col_" + key}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              {report.title}
                            </p>
                            <h4 className="mb-0">
                              {isLoading ? "..." : report.description}
                            </h4>
                          </div>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                            <span className="avatar-title rounded-circle bg-primary">
                              <i className={"bx " + report.iconClass + " font-size-24"}></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);